module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18484/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp2.svg"